import styled from "@emotion/styled";
import { Dialog } from "react-aria-components";
import { MDSButton, MDSIconButton } from "@/mds/components/buttons";

export const StyledDialog = styled(Dialog)<{ $fluidWidth?: boolean }>`
  background-color: ${({ theme }) => theme.colors.surface.modal};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  padding: 28px 20px;
  box-shadow: ${({ theme }) => theme.shadows.surface};
  border: 1px solid ${({ theme }) => theme.colors.border.surface};
  width: ${({ $fluidWidth }) => ($fluidWidth ? "fit-content" : "min(640px, 90vw)")};
  max-width: 90vw;
  max-height: 90dvh;
  overflow: hidden; /* clip inner scrollbar to rounded corners */
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
`;

export const StyledMDSButton = styled(MDSButton)`
  padding: ${({ theme }) => theme.spacing.sm};
`;

export const StyledDialogHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background-color: ${({ theme }) => theme.colors.surface.modal};
  gap: ${({ theme }) => theme.spacing["2"]};
`;

export const StyledDialogFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md};
  width: 100%;
  position: sticky;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.surface.modal};
  /* Ensure it sits above scrolling content */
  z-index: 1;
`;

export const StyledButtonsLeft = styled.div`
  display: flex;
  margin-right: auto;
`;

export const StyledButtonsRight = styled.div`
  display: flex;
  margin-left: auto;
`;

export const StyledExitButton = styled(MDSIconButton)`
  margin-top: 2px;
  margin-right: 8px;
`;

export const StyledDialogBody = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-gutter: stable;
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: ${({ theme }) => `${theme.colors.grey.x400} transparent`}; /* Firefox */

  /* Inset scrollbar inside rounded corners (WebKit/Blink) */
  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    margin: 8px 0; /* inset from top/bottom only */
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.grey.x400};
    border-radius: ${({ theme }) => theme.borderRadius.large};
    border: 3px solid transparent; /* creates inset effect */
    background-clip: padding-box;
  }
`;
